export enum SidebarTabTypeEnum {
    SALES_INTEL = 'SalesIntel',
    VISITOR_INTEL = 'VisitorIntel',
}
